import(/* webpackMode: "eager" */ "/home/forge/storefront/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/forge/storefront/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"block\",\"preload\":true,\"fallback\":[\"system-ui\",\"arial\"],\"variable\":\"--font-inter\",\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"adjustFontFallback\":true}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/home/forge/storefront/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Manrope\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"block\",\"preload\":true,\"fallback\":[\"system-ui\",\"arial\"],\"variable\":\"--font-manrope\",\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"],\"adjustFontFallback\":true}],\"variableName\":\"manrope\"}");
;
import(/* webpackMode: "eager" */ "/home/forge/storefront/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/home/forge/storefront/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/forge/storefront/src/app/provider/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/forge/storefront/src/app/provider/toaster-provider.tsx");
;
import(/* webpackMode: "eager" */ "/home/forge/storefront/src/assets/css/scrollbar.css");
;
import(/* webpackMode: "eager" */ "/home/forge/storefront/src/assets/css/swiper-carousel.css");
;
import(/* webpackMode: "eager" */ "/home/forge/storefront/src/assets/css/custom-plugins.css");
;
import(/* webpackMode: "eager" */ "/home/forge/storefront/src/assets/css/rc-drawer.css");
;
import(/* webpackMode: "eager" */ "/home/forge/storefront/src/contexts/ui.context.tsx");
